.app {
    overflow-x: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
    .error {
        color: darkred;
        margin: 10px 20px;
    }
    .errorInfo {
        color: #aaa;
        margin-top: 20px;
    }
}
